<template>
  <v-dialog width="350px" persistent v-model="editDialog">
    <v-btn  slot="activator" dark flat class="orange darken-3">
      <v-icon small dark class="text--lighten-1">edit</v-icon>
    </v-btn>
    <v-card>
      <v-container class="mt-0">
        <v-layout row wrap>
          <v-flex xs12 class="mb-2">
            <v-card-title class="justify-center"><h2>Edit Enrollment</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedEnrollments" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12>
            <v-card-text>
            <v-text-field
              name="editedEnrollmentsName"
              v-model="editedEnrollmentsName"
              label="Enrollment"
              id="editedEnrollmentsName"
            ></v-text-field>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedEnrollments" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12>
            <v-card-text>
            <v-select
              name="editedEnrollmentsPriority"
              v-model="editedEnrollmentsPriority"
              :items="editedEnrollmentsPriorityHolder"
              label="Enrollment Priority"
              id="editedEnrollmentsPriority"
            ></v-select>
            </v-card-text>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text primary " @click="onSaveChanges">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['enrollment'],
  data () {
    return {
      editDialog: false,
      editedEnrollments: this.enrollment,
      editedEnrollmentsName: this.enrollment.enrollmentName,
      editedEnrollmentsPriorityHolder: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      editedEnrollmentsPriority: this.enrollment.enrollmentPriority
    }
  },
  computed: {
    loadEnrollments () {
      return this.$store.getters.loadedEnrollments
    }
  },
  methods: {
    onSaveChanges () {
      this.editDialog = false
      this.$store.dispatch('updateEnrollmentData', {
        enrollmentId: this.enrollment.enrollmentId,
        enrollmentName: this.editedEnrollmentsName,
        enrollmentPriority: this.editedEnrollmentsPriority
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditEnrollmentsDialog.vue?14d355f6